<template>
  <div class="home">
    <van-cell-group title="通知" style="margin-bottom: 8vh;;">
      <van-panel title="DXWSOFT系统上线" desc="2020/05/09 12:00" status="new" />
      <van-cell title="版本信息" value="1.1.0" title-class="title">
        <template slot="label">
          <span>考勤核对功能上线</span><br>
          <span>申请审批功能上线</span><br>
          <span>会议预定功能上线</span><br>
        </template>
      </van-cell>
    </van-cell-group>
    <div>
      <van-grid style="background-color:#fff;">
        <van-grid-item icon="clock-o" text="考勤" @click="toWork(1)" />
        <van-grid-item v-show="$store.getters.approval>0" icon="certificate" text="审批" @click="toWork(2)" />
        <!-- <van-grid-item v-show="$store.getters.department=='0000000260'" icon="notes-o" text="资源" @click="toWork(4)" /> -->
        <van-grid-item icon="records" text="会议预定" @click="toWorkPush(5)" />
        <van-grid-item v-if="Userdepartmentdata.length>0 && Userdepartmentdata[0].department.indexOf('0000000262') != -1" icon="icon iconfont icon-qingjiashenqingdan" text="请假申请" @click="leaveApplication()" />
        <van-grid-item icon="gold-coin-o" text="教育积分" @click="toEducationalPoints()" />
        <van-popup v-model="popupleaveCreate" position="bottom" :style="{ height: '100%' }">
          <create v-if="existModel" ref="create" :mode="leavePage.mode" :info="leavePage.info" default-value="home" />
        </van-popup>
        <!-- <van-grid-item icon="records" text="会议预定" @click="toWorkPush(5)" /> -->
        <!-- <van-grid-item icon="notes-o" text="资源" @click="showPopup" />
        <van-popup v-model="show" position="bottom" :style="{ height: '100%' }">
          <resource ref="create" :mode="leavePage.mode" :info="leavePage.info" />
        </van-popup> -->
        <!-- <van-grid-item />
        <van-grid-item /> -->
      </van-grid>
    </div>
  </div>
</template>

<script>
// import resource from './Resource'
// import { getInfo } from '@/utils/auth'
import { GetUserAuthority } from '@/api/EducationalPoints'
import request from '@/utils/request'
import create from './Work/components/Create'
export default {
  name: 'Home',
  components: { create },
  data() {
    return {
      leavePage: {
        mode: true,
        info: {}
      },
      show: false,
      active: 0,
      // 模块是否显示   正式发布请去掉
      mould: false,
      Userdepartmentdata: [],
      popupleaveCreate: false,
      existModel: false
    }
  },
  watch: {},
  created() {
    this.getUserDepartment(this.$store.getters.usercode)
    this.getUserAuthority(this.$store.getters.usercode)
  },
  methods: {
    toWorkPush() {
      this.$router.push(
        { path: '/index/Meeting' }
      )
    },
    toWork(val) {
      this.$parent.active = val
      if (val === 1) {
        console.log('work')
        this.$router.push(
          { path: '/index/work' }
        )
      }
    },
    leaveApplication() {
      this.popupleaveCreate = true
      this.existModel = true
    },
    closePop() {
      this.popupleaveCreate = false
      this.existModel = false
    },
    // 获取员工的组织编号
    getUserDepartment(user_code) {
      const that = this
      request({ url: 'O00/Userdepartment/Get', params: { user_code: user_code }})
        .then(function(response) {
          if (response.code === 0) {
            that.Userdepartmentdata = response.data
          } else {
            that.Userdepartmentdata = []
          }
        })
        .catch(() => {})
    },
    // 跳转教育积分页面
    toEducationalPoints() {
      this.$router.push(
        { path: 'index/EducationalPoints' }
      )
    },
    // 获取用户权限
    getUserAuthority() {
      const that = this
      GetUserAuthority({ user_id: this.$store.getters.usercode }, function(res) {
        if (res.code === 0) {
          that.$store.dispatch('pointvuex/point', res.data)
        } else {
          that.$store.dispatch('pointvuex/point', '3')
        }
      })
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 0.8rem;
}

</style>
